import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const BUYERS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('BUYERS');
export const BUYERS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	BUYERS_CRUD_ACTION_CONSTANTS
);
